import {ApplicationError} from '../common/error.model';
import { Injectable } from '@angular/core';
import { SsoTokenVO,  UserVO} from './sso.models';
import { SigninResponseVO } from "../signin/signin.models";
import { HttpService } from '../http/http.service';
import { SsoService } from './sso.service';
import { environment } from "../../environments/environment"

@Injectable()
export class SsoServiceImpl implements SsoService {
  private tokenVO: SsoTokenVO;
  private userVO: UserVO;

  constructor(private httpService: HttpService) { }

  saveSigninResponse(signinResponseVO: SigninResponseVO): void {
    this.tokenVO = new SsoTokenVO();
    this.tokenVO.setAccessToken(signinResponseVO.getAccessToken());
    this.tokenVO.setRefreshToken(signinResponseVO.getRefreshToken());

    this.userVO = new UserVO();
    this.userVO.setId(signinResponseVO.getId());
    this.userVO.setEmailId(signinResponseVO.getEmailId());
    this.userVO.setFirstName(signinResponseVO.getFirstName());
    this.userVO.setLastName(signinResponseVO.getLastname());
    // TODO - setup all fields of the VO

  }

  updateUserDetails(userVO: UserVO): void{
    this.userVO = new UserVO(userVO);
  } 

  clear(): void {
    this.tokenVO = null;
    this.userVO = null;
  }

  getToken(refreshIfExpired: boolean): Promise<SsoTokenVO> {
    // TODO - return token from this.tokenVO , if not expired
    // If token is expired, call token refresh api by passing refresh token
    // If this api also fails, return error
    var tokenParts = this.tokenVO.getAccessToken().split('.');
    let tokenBody = JSON.parse(atob(tokenParts[1]));
    
    if(refreshIfExpired && Date.now()>tokenBody.exp){
      console.log("Token expired.... Refreshing token");
      let url = `${environment.SSO_API_ENDPOINT}/token/refresh`;
      console.log('url = ' + url);
      let headers = new Headers({
        'Authorization': 'Bearer ' + this.tokenVO.getAccessToken(),
        'Content-Type': 'application/json'
      });
    console.log("Previous token :" + this.tokenVO.getAccessToken());
      return this.httpService.post(url, this.tokenVO, headers).toPromise()
        .then(responseEnvelope => {
          if (responseEnvelope) {
            console.log("Setting the access Token : " + responseEnvelope.getBody().accessToken);
            this.tokenVO = new SsoTokenVO();
            this.tokenVO.setAccessToken(responseEnvelope.getBody().accessToken);
            this.tokenVO.setRefreshToken(responseEnvelope.getBody().refreshToken);
            console.log(JSON.stringify(this.tokenVO));
            return this.tokenVO;
          } else {
            console.error("Resposne received from refresh REST service is empty. " + responseEnvelope);
            throw new ApplicationError("INVALID_REFRESH_RESPONSE", "Refresh failed", null);
          }
        }, error => {
          console.error("Error received in refresh service. " + JSON.stringify(error));
          throw error;
        });
    }
    else{
      return Promise.resolve(this.tokenVO);
    }
  }

  getUserDetails(): UserVO{
    return this.userVO;
  }

}


// WEBPACK FOOTER //
// ./src/app/sso/sso.service.impl.ts